import { ActionBar, Icon } from '@fourthwall/components';
import { HeartIcon } from '@fourthwall/icons';
import React from 'react';
export const ThankYousBarView = ({ title, onClick }) => {
    return (React.createElement(ActionBar, { title: title, icon: React.createElement(Icon, { component: HeartIcon, height: 16 }), onClick: onClick }));
};
